import { render, staticRenderFns } from "./mainText.vue?vue&type=template&id=21bf7acd&scoped=true&"
import script from "./mainText.vue?vue&type=script&lang=js&"
export * from "./mainText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf7acd",
  null
  
)

export default component.exports